module.exports = __webpack_public_path__ + "img/empty.ebe8a24c.png";